import React, { useState, useEffect } from 'react'
const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const [show, setShow] = useState(true);

    const [lastScrollY, setLastScrollY] = useState(0);



    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setScrollY(currentScrollY);

            if (currentScrollY > lastScrollY && currentScrollY > 200) {
                // Scroll down
                setShow(false);
            } else if (currentScrollY < lastScrollY) {
                // Scroll up
                setShow(true);
            }

            setLastScrollY(currentScrollY);
        };

        // Add event listener for scroll when component mounts
        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove event listener when component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);


    useEffect(() => {
        const handleScroll = () => {
            if (isOpen) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        };

        // Add event listener for scroll when component mounts
        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove event listener when component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isOpen]);


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 990) {
                setIsOpen(false);
                document.body.style.overflow = 'auto';
            }
        };

        // Add event listener for resize when component mounts
        window.addEventListener('resize', handleResize);

        // Cleanup function to remove event listener when component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        // Add event listener for scroll when component mounts
        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove event listener when component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={`relative ${!show && 'hidden'}`}>
            <div className={`fixed z-20 w-screen ${scrollY > 100 && 'bg-primary bg-opacity-85'}`}>
                <div className='container mx-auto px-4 md:px-6'>
                    <div className='flex justify-between items-center py-4'>
                        <a className='' href='/'>
                            <img src='/assets/images/logo-white.png' alt="" className='w-36' />
                        </a>
                        <div className='lg:block hidden'>
                            <ul className='m-0 p-0 flex gap-4 md:pr-12'>
                                <li className='text-white'>
                                    <a href="/#stories">
                                        Success Stories
                                    </a>
                                </li>
                                <li className='text-white'>
                                    <a href="/#howitworks">
                                        How It Works
                                    </a>
                                </li>
                                <li className='text-white'>
                                    <a href="/#areawecover">
                                        Areas We Cover
                                    </a>
                                </li>
                                <li className='text-white'>
                                    <a href="/#team">
                                        Legal Team
                                    </a>
                                </li>
                               
                                <li className='text-white'>
                                    <a href="/#contactus">
                                        Contact Us
                                    </a>
                                </li>
                             
                            </ul>
                        </div>
                        {/* <div className='hidden lg:flex flex-col justify-center items-center '>
                            <p className='text-white'>Free Call 24/7</p>
                            <h2 className='text-white text-3xl'>123-456-7890</h2>
                        </div> */}
                        <button className='block lg:hidden' onClick={() => setIsOpen(true)}>
                            <img src='/assets/images/menu.svg' alt='' />
                        </button>
                    </div>
                </div>
            </div>

            {
                isOpen &&
                <div className="absolute w-screen bg-gray-500 h-screen bg-opacity-75 min-w-screen lg:hidden">
                    <div className="fixed z-50 right-0 bg-white h-screen min-w-64">
                        <div className='flex justify-end px-5 mt-5'>
                            <button className='font-bold text-2xl ' onClick={() => setIsOpen(false)}>x</button>
                        </div>
                        <ul className='m-0 p-0 pt-4'>
                            <li className='text-black font-bold px-4 py-2' onClick={() => setIsOpen(false)}>
                                <a href="/#stories">
                                    Success Stories
                                </a>
                            </li>
                            <li className='text-black font-bold px-4 py-2' onClick={() => setIsOpen(false)}>
                                <a href="/#howitworks">
                                    How It Works
                                </a>
                            </li>
                            <li className='text-black font-bold px-4 py-2' onClick={() => setIsOpen(false)}>
                                <a href="/#areawecover">
                                    Areas We Cover
                                </a>
                            </li>
                            <li className='text-black font-bold px-4 py-2' onClick={() => setIsOpen(false)}>
                                <a href="/#team">
                                    Legal Team
                                </a>
                            </li>
                         
                            <li className='text-black font-bold px-4 py-2' onClick={() => setIsOpen(false)}>
                                <a href="/#contactus">
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            }

        </div>

    )
}

export default Navbar